<div *ngFor="let student of students">
  <app-student-detail [student]="student" />
</div>
